import { render } from "./AssignAddonModal.vue?vue&type=template&id=a033a91c&ts=true"
import script from "./AssignAddonModal.vue?vue&type=script&lang=ts"
export * from "./AssignAddonModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__